import React from 'react'
import { SilkFallback } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/Common'
import { getSelectionStatus } from '@core/Areas/Account/Pages/Activity/Components/Ticket/helpers'
import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'
import type { RaceCodesLowerCase } from '@core/Areas/Racing/Types/MeetingInformation'
import { StatusSilkStyled } from '../../StatusSilks.styles'
import { BetStatusIcon } from '../BetStatusIcon'

export const SelectionStatusSilks: React.FC<{
  selections: Ticket['legs'][0]['selections']
  contestType?: RaceCodesLowerCase
}> = ({ contestType, selections }) => {
  return (
    <>
      {selections.map(selection => {
        const betStatus = getSelectionStatus(selection)
        const shouldRenderStatusIcon = betStatus && ['Won', 'Lost'].includes(betStatus)

        return shouldRenderStatusIcon ? (
          <BetStatusIcon betStatus={betStatus} key={selection.header} />
        ) : (
          <StatusSilkStyled key={selection.header}>
            <SilkFallback contestType={contestType} isSmall={true} />
          </StatusSilkStyled>
        )
      })}
    </>
  )
}
